import { IconSymbol, IconVariant, IconVariantColor } from './Icon.types';

type IconImage = {
  key: string;
  dataUrl: string;
};

const staticIconImageCache = new Map<string, IconImage>();

export function getIconImage(
  symbol: IconSymbol,
  variant?: IconVariant,
  color?: string,
): string | null {
  const key = `${symbol}${variant ? '_' + variant : ''}${color ? '_' + color : ''}`;
  if (!staticIconImageCache.has(key)) {
    let dataUrl = getSVGDataUrlFromSymbol(symbol);
    if (dataUrl) {
      const c = color ? color : IconVariantColor[variant ?? IconVariant.normal];
      dataUrl = dataUrl?.replaceAll('currentColor', c.replace('#', '%23'));
      const newIconImage = {
        key: key,
        dataUrl: dataUrl,
      };
      staticIconImageCache.set(key, newIconImage);
    }
  }
  const icon = staticIconImageCache.get(key);
  return icon ? icon.dataUrl : null;
}

function getSVGDataUrlFromSymbol(symbolId: string): string | null {
  const symbol = document.getElementById(symbolId);
  if (!symbol) return null;
  const viewBox = symbol.getAttribute('viewBox') || '0 0 24 24';
  const inner = symbol.innerHTML;
  const svgString = `
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="${viewBox}">
      ${inner}
    </svg>`;
  const encoded = encodeURIComponent(svgString)
    .replace(/'/g, '%27')
    .replace(/"/g, '%22');

  return `data:image/svg+xml,${encoded}`;
}
